import React, { useState, useEffect, useContext } from "react";
import { Button, TextField, Chip, Grid, Paper, Typography, Box } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import { getFirestore, collection, addDoc, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { useNavigate } from "react-router-dom"; // Ensure this is imported


const EmployeeWorkLog = ({isAdmin, isWorker }) => {
  const navigate = useNavigate(); // Initialize navigate
  const [remarks, setRemarks] = useState("");
  const [timeSpent, setTimeSpent] = useState("");
  const [checkedItems, setCheckedItems] = useState([]);
  const [services, setServices] = useState([]); // Stores services fetched from Firestore
  const [newServiceName, setNewServiceName] = useState(""); // For adding new service
  const db = getFirestore();
  // const [isLoggedIn, setIsLoggedIn] = useState(false);
  // const [isAdmin, setIsAdmin] = useState(false);
  // const [isWorker, setIsWorker] = useState(false);
  const [userData, setUserData] = useState({});


  // useEffect(() => {
  //   // Check for JWT token in session storage to set login status
  //   const token = sessionStorage.getItem('jwtToken');
  //   if (token) {
  //     setIsLoggedIn(true);
  //     verifyToken(token); // Call verifyToken with the token to check roles
  //   } else {
  //     setIsLoggedIn(false);
  //     setIsAdmin(false);
  //     setIsWorker(false);
  //   }
  // }, []);

  // Token verification function
  // const verifyToken = async (token) => {
  //   console.log("Retrieved JWT Token from session storage:", token);

  //   try {
  //     // Call the API to verify the token
  //     const response = await fetch(`${process.env.REACT_APP_DECODE_TOKEN_API_URL}`, {
  //       method: 'GET',
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });
  //     console.log("API Response Status:", response.status);

  //     const data = await response.json();
  //     console.log("API Response Data:", data);

  //     if (response.ok) {
  //       if (data.role === 'Admin') {
  //         setIsAdmin(true);
  //         setIsWorker(false);
  //         console.log("User is Admin, setting isAdmin to true.");
  //       } else if (data.role === 'Worker') {
  //         setIsAdmin(false);
  //         setIsWorker(true);
  //         console.log("User is Worker, setting isWorker to true.");
  //       } else {
  //         setIsAdmin(false);
  //         setIsWorker(false);
  //         console.log("User role not Admin or Worker, setting both to false.");
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error verifying token:", error);
  //     setIsAdmin(false);
  //     setIsWorker(false);
  //   }
  // };

  // Fetch services from Firestore on component load
  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    const querySnapshot = await getDocs(collection(db, "services"));
    const fetchedServices = [];
    querySnapshot.forEach((doc) => {
      fetchedServices.push({ id: doc.id, ...doc.data() });
    });
    setServices(fetchedServices); 
  };

  const handleRemarksChange = (event) => {
    setRemarks(event.target.value);
  };

  const handleTimeSpentChange = (event) => {
    setTimeSpent(event.target.value);
  };

  const handleChipClick = (label) => {
    setCheckedItems((prevItems) =>
      prevItems.includes(label)
        ? prevItems.filter((item) => item !== label)
        : [...prevItems, label]
    );
  };

  const handleAddService = async () => {
    if (newServiceName.trim() !== "") {
      const newService = { label: newServiceName, color: '#1976d2' };
      try {
        await addDoc(collection(db, 'services'), newService);
        setNewServiceName(""); // Clear the input field
        fetchServices(); // Refresh the list of services
      } catch (error) {
        console.error('Error adding service to Firestore: ', error);
      }
    }
  };

  const handleDeleteService = async (id) => {
    try {
      await deleteDoc(doc(db, 'services', id));
      fetchServices(); // Refresh the list of services after deletion
    } catch (error) {
      console.error('Error deleting service from Firestore: ', error);
    }
  };

  const handleSubmit = async () => {
    const currentDate = new Date();
    const data = {
      remarks: remarks,
      timeSpent: timeSpent,
      checkedItems: checkedItems,
      date: currentDate
    };
    try {
      await addDoc(collection(db, 'activities_selected'), data);
      // Optional: Clear fields after submit
      setRemarks("");
      setTimeSpent("");
      setCheckedItems([]);
    } catch (error) {
      console.error('Error saving data to Firestore: ', error);
    }
  };

  // Updated handleCancel function to include navigation
  const handleCancel = () => {
    setRemarks("");
    setTimeSpent("");
    setCheckedItems([]);
    navigate("/home"); // Redirect to home page
  };

  return (
    <Box sx={{ padding: 4 }}>
      <Paper elevation={3} sx={{ padding: 3, borderRadius: 2 }}>
        <Typography variant="h4" gutterBottom sx={{ color: '#1976d2' }}>
          Services
        </Typography>

        <Grid container spacing={2}>
  {services.map((service) => (
    <Grid item xs={4} key={service.id}>
      <Chip
        label={service.label}
        variant={checkedItems.includes(service.label) ? "filled" : "outlined"}
        onClick={() => handleChipClick(service.label)}
        sx={{
          width: '100%',
          fontSize: '1rem',
          padding: 1,
          backgroundColor: checkedItems.includes(service.label) ? service.color : 'transparent',
          color: checkedItems.includes(service.label) ? '#fff' : service.color,
          borderColor: service.color,
        }}
        // Only show delete functionality if user is an admin
        onDelete={isAdmin ? () => handleDeleteService(service.id) : undefined}
        deleteIcon={isAdmin ? <DeleteIcon /> : undefined}
      />
    </Grid>
  ))}
</Grid>

        {isAdmin&&(<Box sx={{ marginTop: 4 }}>
          <TextField
            label="Add New Service"
            variant="outlined"
            fullWidth
            value={newServiceName}
            onChange={(e) => setNewServiceName(e.target.value)}
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: '#1976d2',
                },
                '&:hover fieldset': {
                  borderColor: '#1976d2',
                },
              },
            }}
          />
          <Button
            variant="contained"
            sx={{ marginTop: 2, backgroundColor: '#1976d2', '&:hover': { backgroundColor: '#1565c0' } }}
            onClick={handleAddService}
          >
            Add Service
          </Button>
        </Box>)}

        <Box sx={{ marginTop: 4 }}>
          <TextField
            label="Additional Remarks"
            multiline
            rows={4}
            variant="outlined"
            fullWidth
            value={remarks}
            onChange={handleRemarksChange}
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: '#1976d2',
                },
                '&:hover fieldset': {
                  borderColor: '#1976d2',
                },
              },
            }}
          />
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', marginTop: 3 }}>
          <TextField
            type="number"
            label="Time Spent"
            variant="outlined"
            value={timeSpent}
            onChange={handleTimeSpentChange}
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: '#1976d2',
                },
                '&:hover fieldset': {
                  borderColor: '#1976d2',
                },
              },
            }}
          />
        </Box>

        <Box sx={{ marginTop: 4, display: 'flex', justifyContent: 'space-between' }}>
          <Button
            variant="contained"
            sx={{ backgroundColor: '#388e3c', '&:hover': { backgroundColor: '#2e7d32' } }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
          <Button
            variant="contained"
            sx={{ backgroundColor: '#d32f2f', '&:hover': { backgroundColor: '#c62828' } }}
            onClick={handleCancel}
          >
            Cancel
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default EmployeeWorkLog;